import get from 'lodash/get';

const getDisableAllFields = props =>
  get(props, 'settings.disableAllFields', false);

export default getDisableAllFields;
